import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
	// - -  ENGLISH

	en: {
		translation: {
			signup: {
				headerLbl: 'Sign up',
				submitButtonLabel: 'Create account',
				gotoSignInButtonLabel: 'sign in',
				gotoConfirmAcountButtonLabel: 'confirm acount',
				facebookBtnLabel: 'Login with Facebook',
				usernameInputLabel: 'Username',
				passwordInputLabel: 'Password',
				emailInputLabel: 'Email address',
				phoneInputLabel: 'Phone number'
			},

			signin: {
				headerLbl: 'Sign in',
				submitButtonLabel: 'Sign in',
				gotoCreateAcountButtonLabel: 'create acount',
				gotoResetPasswordButtonLabel: 'reset password',
				usernameInputLabel: 'Username',
				passwordInputLabel: 'Password',
				codeInputLabel: 'Verification code'
			},

			confirmSignUp: {
				headerLbl: 'Confirm Sign up',
				usernameInputLabel: 'Username',
				codeInputLabel: 'Verification code',
				submitButtonLabel: 'Confirm',
				gotoSignInButtonLabel: 'back to sign in',
				resendCodeButtonLabel: 'resend verification code'
			},

			requestResetPassword: {
				headerLbl: 'Request a password reset',
				usernameInputLabel: 'Username',
				submitButtonLabel: 'Submit',
				gotoSignInButtonLabel: 'back to sign in',
				gotoResetPasswordButtonLabel: 'reset password'
			},

			resetPassword: {
				headerLbl: 'Reset password',
				submitButtonLabel: 'Submit',
				usernameInputLabel: 'Username',
				codeInputLabel: 'Code',
				newPasswordInputLabel: 'New password',
				gotoSignInButtonLabel: 'back to sign in'
			},

			settings: {
				headerLbl: 'Confirm phone',
				codeInputLabel: 'Verification code',
				sendSMSButtonLabel: 'Send SMS',
				submitButtonLabel: 'Confirm',
				verificationDesciription: 'Confirm you mobile phone by sending an sms with a verification code. After recieving the code, please type it in the field below and press confirm.'
			},
			// - -

			userMenu: {
				accountButtonLabel: 'Acount',
				settingsButtonLabel: 'Settings',
				signOutButtonLabel: 'Sign out'
			}
		}
	},

	// - -  DUTCH

	nl: {
		translation: {
			signup: {
				headerLbl: 'Inschrijven',
				submitButtonLabel: 'Maak acount',
				gotoSignInButtonLabel: 'inloggen',
				gotoConfirmAcountButtonLabel: 'bevestig acount',
				facebookBtnLabel: 'Login met Facebook',

				usernameInputLabel: 'Gebruikersnaam',
				passwordInputLabel: 'Wachtwoord',
				emailInputLabel: 'Email adres',
				phoneInputLabel: 'Telefoon nummer'
			},
			signin: {
				headerLbl: 'Inloggen',
				submitButtonLabel: 'Inloggen',

				gotoCreateAcountButtonLabel: 'inschrijven',
				gotoResetPasswordButtonLabel: 'wachtwoord hertellen',

				//

				usernameInputLabel: 'Gebruikersnaam',
				passwordInputLabel: 'Wachtwoord',
				codeInputLabel: 'Verificatie code'
			},
			confirmSignUp: {
				headerLbl: 'Bevestig inschrijving',
				usernameInputLabel: 'Gebruikersnaam',
				codeInputLabel: 'Verificatie code',
				submitButtonLabel: 'Bevestigen',
				gotoSignInButtonLabel: 'terug naar login',
				resendCodeButtonLabel: 'Verstuur nieuwe verificatie code'
			},

			requestResetPassword: {
				headerLbl: 'Vraag een nieuw wachtwoord aan',
				usernameInputLabel: 'Gebruikersnaam',
				submitButtonLabel: 'Verstuur',
				gotoSignInButtonLabel: 'terug naar login',
				gotoResetPasswordButtonLabel: 'herstel wachtwoord'
			},

			resetPassword: {
				headerLbl: 'Vernieuw wachtwoord',
				submitButtonLabel: 'Verstuur',
				usernameInputLabel: 'Gebruikersnaam',
				codeInputLabel: 'Verificatie code',
				newPasswordInputLabel: 'Nieuw wachtwoord',
				gotoSignInButtonLabel: 'terug naar inloggen'
			},

			settings: {
				headerLbl: 'Bevestig telefoon',
				codeInputLabel: 'Verificatie code',
				sendSMSButtonLabel: 'Verstuur SMS',
				submitButtonLabel: 'Bevestigen',
				verificationDesciription: 'Verifieer je mobiele toestel via een SMS. Nadat je de SMS hebt ontvangen voer je de code in en klik op bevestig.'
			},

			// - -

			userMenu: {
				accountButtonLabel: 'Acount',
				settingsButtonLabel: 'Instellingen',
				signOutButtonLabel: 'Uitloggen'
			}
		}
	}
};

i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
		debug: true,
		fallbackLng: 'en',
		lng: 'nl',
		//lng: 'en',

		keySeparator: true, // we do not use keys in form messages.welcome

		interpolation: {
			escapeValue: false // react already safes from xss
		}
	});

export default i18n;
